import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {EquipmentEnums, EquipmentInterfaces} from '@namespaces/equipment.namespace';
import {EquipmentService} from '../../services/equipment.service';
import {EquipmentPreview} from './equipment-preview';
import {EquipmentSelectControlService} from '../../services/equipment-select-control.service';
import {EquipmentSelect} from '../../equipment-select.namespace';
import ViewStatus = EquipmentSelect.ViewStatus;
import {EquipmentCreateOptionsService} from '@services/equipment-create-options.service';
import {EventsService} from '@services/events.service';

@Component({
    selector: 'app-equipment-preview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'equipment-preview.component.html',
    styles: [`
        :host {
            display: block;
        }

        [data-equipment-preview] {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        [data-equipment-preview] button {
            margin-top: auto;
        }

        img {
            /* Убираем whitespace под картинкой, делая ее блоком */
            display: block;
        }
    `]
})

export class EquipmentPreviewComponent implements OnInit {
    @Input() equipmentId: number;
    @Input() defaultEquipment: EquipmentInterfaces.Model;
    @Input() showResetButton = true;

    @HostBinding('style.display') get _display() {
        return this.equipment ? 'block' : 'none';
    }

    public equipment: EquipmentPreview;

    constructor(
        private getByIdService: EquipmentService,
        private equipmentSelectControl: EquipmentSelectControlService,
        private equipmentCreateOptions: EquipmentCreateOptionsService,
        private events: EventsService,
    ) {}

    ngOnInit() {
        if (this.defaultEquipment) {
            this.equipment = new EquipmentPreview(this.defaultEquipment);
        } else {
            this.equipmentSelectControl.setViewStatus(ViewStatus.search);
        }
    }

    handleClearClick() {
        const isSafeTOModelChange = this.equipmentCreateOptions.safeModelChangeStatus;

        if (isSafeTOModelChange) {
            this.equipmentSelectControl.setViewStatus(ViewStatus.search);
        } else {
            this.events.showConfirm({
                title: 'Вы уверены, что хотите выбрать другую модель?',
                message: 'При выборе другой модели все параметры формы будут сброшены ',
                confirmButtonTitle: 'Сменить модель'
            }).subscribe(() => {
                this.equipmentSelectControl.setViewStatus(ViewStatus.search);
                this.equipmentCreateOptions.setSafeModelChangeStatus(true);
            }, () => {});
        }
    }
}
